import httpClient from "../../configs/http-client";
import apiUrl from "../../constants/apiUrl";


export const getCountriesAndBlockedPhonePrefix = async () => httpClient.get(
    apiUrl.OTP_GET_COUNTRIES_AND_BLOCKED_PHONE_PREFIX
);

export const sendPhoneNumber = async (countryCode: string, countryCallingCode: string, phoneNumber: string) => httpClient.post(
    apiUrl.OTP_SEND_PHONE_NUMBER,
    {
        country_code: countryCode,
        country_calling_code: countryCallingCode,
        phone_number: phoneNumber
    }
);

export const sendOTP = async (OTP: string, phoneNumber: string) => httpClient.post(
    apiUrl.OTP_SEND_OTP,
    { otp: OTP, phone_number: phoneNumber }
);
